import { hrms, hrmsWithPath } from '../../services/http/api/rest';
import { NoteStatus } from "../../domains/models/note";

const rest = hrmsWithPath('/v1/note');

const notes = {
    list: (searchData?: any) => rest.post('/search', {}, searchData,{},{'content-type':'application/json'}),
    create: (data: any) => rest.post('', {}, data,{},{'content-type':'application/json'}),
    update: (noteId: string, data: any) => rest.put(`/${noteId}`, {}, data),
    delete: (noteId: string) => rest.del(`/${noteId}`, {}),
    updateStatus: (id: string, status?: NoteStatus, isPinned?: boolean) =>
        rest.put('/{{id}}/update', {id}, {}, {
            status: status,
            pinned: isPinned
        })
}

export default notes;
